import provinceTH from "../utils/json/changwats/th.json";
import districtTH from "../utils/json/amphoes/th.json";
import subDistrictTH from "../utils/json/tambons/th.json";
import postcodeTH from "../utils/json/postcodes/th.json";

export const provinceOption = provinceTH.th.changwats.map((item) => {
  return {
    label: item.name,
    value: item.name,
    province_code: item.pid,
  };
});

export const districtOption = districtTH.th.amphoes.map((item) => {
  return {
    label: item.name,
    value: item.name,
    province_code: item.changwat_pid,
    district_code: item.pid,
  };
});

export const subDistrictOption = subDistrictTH.th.tambons.map((item) => {
  return {
    label: item.name,
    value: item.name,
    province_code: item.changwat_pid,
    district_code: item.amphoe_pid,
    sub_district_code: item.pid,
  };
});

export const postcodeOption = postcodeTH.th.postcodes.map((item) => {
  return {
    label: item.zipcode,
    value: item.zipcode,
    province_code: item.province_code,
    district_code: item.amphoe_code,
    sub_district_code: item.district_code,
  };
});
